import type { JSX } from 'react';

import { Typography } from '@mui/material';
import { getOptionLabelDefaultCallback, isOptionEqualToValueDefaultCallback } from 'common/components/sharedCustomComponents/Common/helpers';
import { EntitiesSearchableCommonDropDown } from 'common/components/sharedCustomComponents/EntitiesSearchableCommonDropDown/EntitiesSearchableCommonDropDown';
import { fetchImportTypes } from 'common/services/api/Imports/Imports.thunk';
import { ImportType } from 'common/types/Entities';

export function ImportTypesSearchableDropDown(props: Readonly<{
    onChange: (event: unknown, value: ImportType | null) => void,
    supportedTemplates: string[],
    value?: ImportType | null,
}>) {
    const { value, onChange, supportedTemplates } = props;

    const displayImportTypeOptionMenuItemContent = (option: ImportType | null): JSX.Element => {
        return (
            <Typography>
                {option?.name}
            </Typography>
        );
    };

    return (
        <EntitiesSearchableCommonDropDown
            initialEntityOption={{ name: '', id: '' }}
            value={value}
            onChange={onChange}
            label='Import Type'
            getOptionLabel={getOptionLabelDefaultCallback}
            isOptionEqualToValue={isOptionEqualToValueDefaultCallback}
            asyncThunkAction={fetchImportTypes}
            asyncThunkArgs={supportedTemplates}
            displayMenuItemContent={displayImportTypeOptionMenuItemContent}
            effectDependecyArray={[]}
        />

    );
}
